'use client';

import {
  ControllerRenderProps,
  FieldValues,
  UseFormReturn,
} from 'react-hook-form';

import { Input, InputProps } from '@nextui-org/react';

import {
  FormControl,
  FormField,
  FormItem,
  useFormField,
} from '@/components/ui/form';

interface Props extends InputProps {
  formReactHookForm: UseFormReturn<any>;
  name: string;
}
export const FormInput = ({ formReactHookForm, ...props }: Props) => {
  return (
    <FormField
      control={formReactHookForm.control}
      name={props.name}
      render={({ field }) => <FormItemInput {...props} {...field} />}
    />
  );
};

const FormItemInput = (
  props: Omit<Props, 'formReactHookForm'> &
    ControllerRenderProps<FieldValues, string>,
) => {
  const { error } = useFormField();
  return (
    <FormItem>
      <FormControl>
        <Input
          {...props}
          errorMessage={error?.message ?? props.errorMessage}
          isInvalid={!!error?.message || props.isInvalid}
          color={error?.message ? 'danger' : (props.color ?? 'default')}
        />
      </FormControl>
      {/*<FormMessage />*/}
    </FormItem>
  );
};
